import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import bgImg1 from '../assets/bg-img-1.jpg';
import useToken from '../context/useToken';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const ServiceComponent = () => {
  const token = useToken();
  const { endpoints } = useParams();
  const [service, setService] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editedService, setEditedService] = useState({ title: '', description: '', icon: '' });
  const [uploadedIcon, setUploadedIcon] = useState('');

  // Function to fetch service data from the API
  const fetchServiceData = async () => {
    try {
      const response = await axios.get(
        `https://thecfagroup.org/v1/api/services/${endpoints}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': '*/*'
          }
        }
      );
      setService(response.data); // Set the service data in state
      setEditedService({
        title: response.data.title,
        description: response.data.description,
        icon: response.data.icon || ''
      });
      setUploadedIcon(response.data.icon || '');
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  // Fetch service data when the component mounts
  useEffect(() => {
    window.scroll(0, 0);
    if(token)
    fetchServiceData();
  }, [endpoints,token]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedIcon(file); // Store the file for API upload
    }
  };

  const handleEditService = async () => {
    try {
      const formData = new FormData();
      formData.append('title', editedService.title || '');
      formData.append('subtitle', editedService.subtitle || '');
      formData.append('description', editedService.description || '');
      formData.append('isActive', true);
      if (uploadedIcon) {
        formData.append('headerImage', uploadedIcon, 'iconImage.jpg'); // Assuming the image format is .jpg
      }
  
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`, // Add the token from useToken
          'Content-Type': 'multipart/form-data',
        },
      };
  
      const response = await axios.put(
        `https://thecfagroup.org/v1/api/services/${endpoints}`, // Use dynamic endpoint ID
        formData,
        config
      );
  
      fetchServiceData()
     // Close the modal after saving
      setShowModal(false)
      console.log('Service updated successfully:', response.data);
    } catch (error) {
      console.error('Error updating service:', error);
    }
  };

  if (!service) {
    return <div>Loading service...</div>;
  }

  return (
    <div>
      <div
        className="relative h-[50vh] bg-cover bg-center z-1"
        style={{ backgroundImage: `url(${service.headerImage})` }}
      >
        <div className="absolute inset-0 bg-[#03000c] opacity-75"></div>
        <div className="absolute z-1 flex flex-col items-start justify-center min-h-full w-[70%] px-4 mt-6 sm:px-10 md:px-16">
          <div className="flex gap-6 items-center text-white text-left px-4 py-6 w-full max-w-3xl mx-auto">
            <h1 className="text-[40px] sm:text-[50px] md:text-[70px] font-extrabold leading-tight mb-4 animate-fade-in-up">
              {service.title}
            </h1>
            {token && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-16 h-16 cursor-pointer mt-2"
                onClick={() => setShowModal(true)}
              >
                <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
              </svg>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center py-16 px-4 md:px-8 lg:px-16 bg-gray-100">
        <div className="w-full max-w-6xl p-8 bg-white shadow-xl rounded-lg">
          <h1 className="flex gap-2 items-center text-3xl md:text-5xl font-bold mb-6 text-left text-[#25a182]">
            <img src={service.iconImage || bgImg1} alt="service_icon" className="w-14 h-14" />
            {service.title}
          </h1>
          {/* <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">
            {service.description}
          </p> */}
          <div dangerouslySetInnerHTML={{ __html: service.description }} className="py-8 text-black text-lg font-poppinsRegular" />
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-[80%] h-[650px]">
            <h3 className="text-2xl font-semibold mb-4">Edit Service</h3>
            <input
              type="text"
              placeholder="Enter Service Title"
              value={editedService.title}
              onChange={(e) => setEditedService({ ...editedService, title: e.target.value })}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />
            <CKEditor
              editor={ClassicEditor}
              
              data={editedService.description}
              onChange={(event, editor) => {
                const data = editor.getData();
                setEditedService({ ...editedService, description: data });
              }}
              config={{
                placeholder: "Enter Service Description",
                height: '400px', // Increase the editor height
                minHeight: '400px', // Set a minimum height
              }}
            />

            <input
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />
            <div className="flex justify-end gap-4">
              <button
                onClick={handleEditService}
                className="bg-[#25a182] text-white px-6 py-2 rounded shadow hover:bg-[#1f795e]"
              >
                Save
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-400 text-white px-6 py-2 rounded shadow hover:bg-gray-500"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceComponent;
